import React from "react";
import { benefits } from "../data/content";
import "./Benefits.css";

export default function Benefits() {
  return (
    <section className="benefits-section" id="benefits">
      <span className="section-eyebrow benefits-eyebrow">Why It Works</span>
      <h2 className="section-title benefits-title">
        5 Ways It Supports
        <br />
        Your Wellness Journey
      </h2>
      <p className="section-sub benefits-sub">
        A synergistic blend that addresses multiple aspects of metabolic and
        overall health.
      </p>

      <div className="benefits-grid">
        {benefits.map((item) => {
          const Icon = item.icon;
          return (
            <div className="ben-card" key={item.title}>
              <span className="ben-icon">
                {typeof Icon === "string" ? (
                  Icon
                ) : (
                  <Icon size={20} />
                )}
              </span>
              <div className="ben-title">{item.title}</div>
              <p className="ben-desc">{item.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
